﻿module.exports = san.defineComponent({
    template: require('../views/intelligent-document-index.html'),
    initData: function () {
        return {
            documentList: [],//文书列表
            data: {
                title:'',
                page: 1,
                limit: 10,
                type: '',
                type2: '',
            },
            typeTitle: '',
            typeList: [],
            fieldList: [],
            fieldName: '',
            showFlag: true,
            sw: true,// 设置一个开关来避免下拉时重复请求数据
            isState: true,//显示状态
            stateName: '加载中，请稍后...',
            showLoading:false,
            currPage: 1,
            totalCount: 0,
            totalPage: 1,
            pageList: [1],
        };
    },
    components: {

    },
    created: function () {
        this.data.set('showFlag',true);
        this.data.set('isState',true);
    },
    inited: function (type, name){
        var me = this;
        me.data.set('typeTitle', name);
        Api("get","/api/tintelligentwrit/v2/typeList?parentId=0&source=ahfw").then(function (response) {
            console.log(response, 111)
            if (response.code === 0) {
                response.list.forEach(function (item) {
                    if(item.type == type){
                        me.data.set('fieldList', item.list)
                    }
                });
                me.data.set('data',{
                    title:'',
                    page: 1,
                    limit: 10,
                    type: response.list[0].type,
                    type2: ''
                });
                me.data.set('typeList', response.list);
                me.data.set('fieldList', response.list);
                me.getList();
            }
        });
    },
    close: function (){
        this.data.set('showFlag',false);
    },
    modelSelect: function (t,id,name,c ) {
        var visitModel, visitModelName;
        switch (t) {
            case 1:
                visitModel = "SMART_WORD-HOUSE";
                visitModelName = "法律文书-房产买卖";
                break;
            case 2:
                visitModel = "SMART_WORD-MARRIAGE";
                visitModelName = "法律文书-婚姻家庭";
                break;
            case 3:
                visitModel = "SMART_WORD-TRAFFIC";
                visitModelName = "法律文书-交通事故";
                break;
            case 4:
                visitModel = "SMART_WORD-LABOR";
                visitModelName = "法律文书-劳动工伤";
                break;
            case 5:
                visitModel = "SMART_WORD-PRIVATE_LEND";
                visitModelName = "法律文书-民间借贷";
                break;
            case 6:
                visitModel = "SMART_WORD-CONTRACT";
                visitModelName = "法律文书-买卖合同";
                break;
            case 7:
                visitModel = "SMART_WORD-QYJY";
                visitModelName = "法律文书-企业经营";
                break;
            case 8:
                visitModel = "SMART_WORD-SSZC";
                visitModelName = "法律文书-诉讼仲裁";
                break;
            case 99:
                visitModel = "SMART_WORD-OTHER";
                visitModelName = "其它";
                break;
            case "":
                visitModel = "SMART_WORD-ALL";
                visitModelName = "法律文书-所有";
                break;
            default:
                visitModel = "SMART_WORD-ALL";
                visitModelName = "法律文书-所有";
                break;
        }
        window.NewLog._saveLog(visitModel, visitModelName, id, name, c);
    },
    search: function (){
        var me = this;
        this.data.set('data.page',1);
        me.nextTick(function(){
            window.Tool._scroll(me.ref('box'),0);
        });
        this.getList();
    },
    show:function(){
        this.data.set('showLoading', true);
    },
    hide:function(){
        this.data.set('showLoading', false);
    },
    getList: function (p) {
        var me = this;
        if (p < 1 || p > me.data.get('totalPage')) {
            return;
        }
        (!!p) ? me.data.set('data.page',p): me.data.set('data.page',1);
        var data = this.data.get('data');
        console.log(data, 222)
        this.show();
        this.data.set('documentList',[]);
        Api("post", "/api/tintelligentwrit/v2/list", JSON.stringify(data)).then(function (response) {
            if (response.code === 0) {
                if(response.page.list.length > 0){
                    var arr = [];
                    response.page.list.forEach(function(vm){
                        me.replaceTitle(vm);
                        //this.setStyle(vm);
                        if(vm.id == 6 || vm.id == 8){
                            arr.unshift(vm);
                        }else {
                            arr.push(vm);
                        }
                    });
                    me.data.set('documentList',[]);
                    san.nextTick(function () {
                        me.data.set('documentList',arr);
                        me.data.set('currPage',response.page.currPage);
                        me.data.set('totalCount',response.page.totalCount);
                        me.data.set('totalPage',response.page.totalPage);
                    });
                    if(response.page.list.length === me.data.get('data.limit')){
                        me.data.set('stateName','下拉加载更多');
                    }else {
                        me.data.set('stateName','无更多数据');
                    }
                }else {
                    me.data.set('documentList',[]);
                    san.nextTick(function () {
                        me.data.set('documentList',response.page.list);
                    });
                    me.data.set('stateName','无更多数据');
                }
            }else {
                me.data.set('stateName','数据加载错误');
            }
            san.nextTick(function (){
                me.getPageList();
                me.hide();
            });
        });
    },
    replaceTitle: function (item){
        if(item.id==14){
            item.title=item.title='申请采取拘留措<br/>施、纳入失信被<br/>执行人名单申请书';
        }
        if(item.id!=14 && item.title.indexOf('起诉状')!=-1){
            item.title=item.title.replace('起诉状','<br/>起诉状')
        }
        if(item.id!=14 && item.title.indexOf('起诉书')!=-1){
            item.title=item.title.replace('起诉书','<br/>起诉书')
        }
        if(item.id!=14 && item.id!=4 && item.id!=7 && item.title.indexOf('仲裁申请书')!=-1){
            item.title=item.title.replace('仲裁申请书','<br/>仲裁申请书')
        }
    },
    setStyle: function (item){
        var data1=[4,7,8,9,10,11,12,13,15,17,18];
        var data2=[1,2,3,5,6,16,19];
        item.distance=0;
        data1.forEach(function(vm){
            if(vm==item.id){
                item.distance = 40;
            }
        });
        data2.forEach(function(vm){
            if(vm==item.id){
                item.distance = 20;
            }
        });
    },
    toDetail: function (id,name,type) {
        this.modelSelect(type,id,name,"SEE" );
        this.dispatch("goDetail",id);
        // this.$router.push({name: 'intelligentDocumentApplication', params: {id: id}})
    },
    changeType: function (type) {
        if (type == this.data.get('data.type')) {
            return;
        }
        this.data.set('sw',true);
        this.data.set('stateName','加载中，请稍后...');
        this.data.set('data',{
            title:'',
            page: 1,
            limit: this.data.get('data.limit'),
            type: ''
        });
        if(type === 0){
            this.data.set('data.type','');
        }else {
            this.data.set('data.type',type);
        }

        this.data.set('fieldList',[]);
        this.data.set('fieldName','');
        var me =this;
        this.data.get('typeList').forEach(function (item) {
            if(item.type == type){
                me.data.set('fieldList',item.list);
                me.data.set('fieldName',item.typeName);
            }
        });
        sessionStorage.aType = JSON.stringify(this.data.get('data.type'));
        this.getList();
    },
    changeCType: function (type) {
        // this.data.set('data.type2', type);
        this.data.set('data.type', type);
        this.getList();
    },
    scrollBottom: function (me) {
        // 滚动到页面底部时，请求前一天的文章内容
        if (((me.ref('box').offsetHeight + me.ref('box').scrollTop - 112) > (me.ref('list').clientHeight)) && me.data.get('sw')) {
            me.data.set('sw',false);
            me.data.set('data.page',me.data.get('data.page') + 1);
            me.data.set('stateName','加载中，请稍后...');
            var data = me.data.get('data');
            Api("post", "/api/tintelligentwrit/v2/list", JSON.stringify(data)).then(function (response) {
                if (response.code === 0) {
                    if(response.page.list.length > 0){
                        response.page.list.forEach(function(vm){
                            me.replaceTitle(vm);
                            me.setStyle(vm);
                        });
                        me.data.get('documentList').push.apply(me.data.get('documentList'),response.page.list);
                        if(response.page.list.length === me.data.get('data.limit')){
                            me.data.set('stateName','下拉加载更多');
                            san.nextTick(function () {
                                me.data.set('sw',true)
                            });
                        }else {
                            me.data.set('stateName','无更多数据');
                        }
                    }else {
                        me.data.set('stateName','无更多数据');
                    }
                }else {
                    me.data.set('stateName','数据加载错误');
                }
            });
        }
    },
    //主页跳转
    homePage: function(p){
        var me = this;
        if (me.data.get('currPage') === 1) {
            return;
        }
        me.getList(p);
    },
    //尾页跳转
    tailPage: function(p){
        var me = this;
        if (me.data.get('currPage') === me.data.get('totalPage')) {
            return;
        }
        me.getList(p);
    },
    //优化页码页面显示范围
    getPageList: function() {
        var min = 1,max = 1;
        var me = this;
        if(!me.data.get('data.page')){
            me.data.set('data.page',1);
        }
        if(me.data.get('data.page') < me.data.get('totalPage') - 15){
            min = me.data.get('data.page') - 15>0?me.data.get('data.page') - 15:1;
            max = me.data.get('data.page') + 15;
        }else if(me.data.get('data.page') <= me.data.get('totalPage')){
            min = me.data.get('data.page') - 15>0?me.data.get('data.page') - 15:1;
            max = me.data.get('totalPage');
        }
        var list = [];
        for(var a = min;max >= a;max --){
            list.unshift(max);
        }
        me.data.set('pageList',[]);
        san.nextTick(function () {
            me.data.set('pageList',list);
        });
    },
    messages: {},
    props: {
        height: {
            default: 35,
            type: Number
        },
        lineNum: {
            default: 5,
            type: Number
        }
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/components/intelligentDocumentIndex.js
// module id = 360
// module chunks = 1